import DataActions from '../../enums/ActionTypes/DataActions'
import {DrawSource} from '../../enums/DrawSource'
import {ensureQuery} from '../../helpers'
import {IActionDispatcher, IFeatureTablesDispatcher, IPaylodAction} from '../../interfaces/dispatchers'
import {IAsyncTableProps, IFeatureLayerInfo, IQuery, ISortingRule, ITableProps} from '../../interfaces/models'
import {IDataQuery, IStore} from '../../interfaces/reducers'
import {Feature} from '../../models'
import {getMapService} from '../../reducers/map'
import {ServiceHub} from '../../ServiceHub'
import {TablesDispatcher} from './tablesDispatcher'
export class FeatureTablesDispatcher extends TablesDispatcher implements IFeatureTablesDispatcher {
  constructor() {
    super()
    this.toggleSelectAll = this.toggleSelectAll.bind(this)
    this.zoomAll = this.zoomAll.bind(this)
    this.refrashTable = this.refrashTable.bind(this)

    this.setFeatureTables = this.setFeatureTables.bind(this)
    this.changePageSize = this.changePageSize.bind(this)
    this.changePage = this.changePage.bind(this)
    this.setSorting = this.setSorting.bind(this)
  }

  protected getQuery(tableProps: ITableProps, layerInfo: IFeatureLayerInfo, dataQuery?: IDataQuery): IQuery {
    const query = {...ensureQuery(tableProps, layerInfo)} as IQuery
    if (dataQuery) {
      if (dataQuery.dataWhere) {
        query.where = dataQuery.dataWhere + ' AND ' + layerInfo.sourceDescription.constantSqlWhere
      }
      if (dataQuery.geometryQuery) {
        query.geometry = dataQuery.geometryQuery.geometry
      }
    }
    return query
  }

  public toggleSelectAll(tableId: string, selectAll?: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const tableProps = getStore().data.featureTables[tableId]
      const layerInfo = getStore().layerInfos.featureLayerInfos[tableId]
      if (tableProps && tableProps.selectedIds && layerInfo) {
        if (tableProps.recordsCount == Object.keys(tableProps.selectedIds).length || selectAll == false) {
          dispatch(this.setTableInfoSelections(tableId, tableProps.selectedIds, false))
        } else {
          if (!tableProps.asyncProps) {
            if (tableProps.data) {
              const allObjectids = {}
              tableProps.data.forEach(d => {
                ;(allObjectids as any)[d.getProperties()[tableProps.idColumnName]!] = d
              })
              dispatch(this.setTableInfoSelections(tableId, allObjectids, true))
            }
          } else {
            tableProps.loading = true
            dispatch({
              type: DataActions.SEND_LOADING_TABLES,
              payload: {[tableProps.id]: tableProps}
            })

            ServiceHub.gisCrudService
              .execute(layerInfo, this.getQuery(tableProps, layerInfo, getStore().dataQueries[layerInfo.url]))
              .then((res: Array<Feature>) => {
                tableProps.loading = false
                const allObjectids = {}
                res.forEach(d => {
                  ;(allObjectids as any)[d.getProperties()[tableProps.idColumnName]!] = d
                })
                dispatch(this.setTableInfoSelections(tableId, allObjectids, true))
              })
              .catch((error: Error) => {
                tableProps.loading = false
                dispatch({
                  type: DataActions.SEND_LOADING_TABLES,
                  payload: {[tableProps.id]: tableProps}
                })
              })
          }
        }
      }
    }
  }

  public refrashTable(tableId: string) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const tableProps = getStore().data.featureTables[tableId]
      const layerInfo = getStore().layerInfos.featureLayerInfos[tableId]
      if (tableProps && layerInfo) {
        if (tableProps.asyncProps) {
          tableProps.asyncProps.page = 0
          dispatch(this.dispatchAsync(layerInfo, tableProps, tableProps.asyncProps))
        } else {
          dispatch(this.dispatchSync(layerInfo, tableProps))
        }
      } else {
        console.warn(`Are you trying to set properties on non-existent table ${tableId} ?`)
      }
    }
  }

  public zoomAll(tableId: string) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      const tableProps = store.data.featureTables[tableId]
      const layerInfo = store.layerInfos.featureLayerInfos[tableId]
      if (tableProps) {
        if (tableProps.asyncProps) {
          if (tableProps.query && layerInfo) {
            dispatch({
              type: DataActions.SET_LOADING,
              payload: true
            })
            const queryLite = {
              ...this.getQuery(tableProps, layerInfo, getStore().dataQueries[layerInfo.url]),
              outFields: []
            } as IQuery
            ServiceHub.gisCrudService
              .execute(layerInfo, queryLite)
              .then(res => {
                const mapService = getMapService()
                mapService.zoomTo(res.filter(r => !!r.getGeometry()).map(r => r.getGeometry()!))
                mapService.drawing.unMark(DrawSource.Select)
                mapService.drawing.mark(res, DrawSource.Select)
                dispatch({
                  type: DataActions.SET_LOADING,
                  payload: false
                })
              })
              .catch(() => {
                dispatch({
                  type: DataActions.SET_LOADING,
                  payload: false
                })
              })
          } else {
            throw new Error('Unfinished...')
          }
        } else {
          const mapService = getMapService()
          mapService.zoomTo(
            (tableProps.data as Array<Feature>).filter(r => !!r.getGeometry()).map(r => r.getGeometry()!)
          )
          mapService.drawing.unMark(DrawSource.Default)
          mapService.drawing.mark(tableProps.data as Array<Feature>, DrawSource.Default)
        }
      }
    }
  }

  protected dispatchSync(layerInfo: IFeatureLayerInfo, tableProps: ITableProps) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      tableProps.loading = true
      dispatch({
        type: DataActions.ADD_SYNC_TABS,
        payload: {[tableProps.id]: tableProps}
      })
      ServiceHub.gisCrudService
        .execute(layerInfo, this.getQuery(tableProps, layerInfo, getStore().dataQueries[layerInfo.url]))
        .then(result => {
          tableProps.data = result
          tableProps.recordsCount = result.length

          tableProps.pages =
            (result.length - (result.length % tableProps.pageSize!)) / tableProps.pageSize! +
            (result.length % tableProps.pageSize! > 0 ? 1 : 0)
          tableProps.loading = false
          delete tableProps.error
          dispatch({
            type: DataActions.ADD_SYNC_TABS,
            payload: {[tableProps.id]: tableProps}
          })
        })
        .catch(error => {
          tableProps.loading = false
          tableProps.error = error
          dispatch({
            type: DataActions.ADD_SYNC_TABS,
            payload: {[tableProps.id]: tableProps}
          })
          dispatch({
            type: DataActions.SET_LOADING,
            payload: false
          })
        })
    }
  }

  public changePageSize(tableId: string, pageSize: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      let tableProps = getStore().data.featureTables[tableId]
      const layerInfo = getStore().layerInfos.featureLayerInfos[tableId]
      if (tableProps && layerInfo) {
        tableProps = {...tableProps, pageSize}
        if (tableProps.asyncProps) {
          dispatch(this.dispatchAsync(layerInfo, tableProps, tableProps.asyncProps))
        } else {
          throw new Error('not implemented yet')
        }
      } else {
        console.warn(`Are you trying to set properties on non-existent table ${tableId} ?`)
      }
    }
  }

  public changePage(tableId: string, page: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const tableProps = getStore().data.featureTables[tableId]
      const layerInfo = getStore().layerInfos.featureLayerInfos[tableId]
      if (tableProps && layerInfo) {
        if (tableProps.asyncProps) {
          tableProps.asyncProps = {...tableProps.asyncProps, page}
          dispatch(this.dispatchAsync(layerInfo, tableProps, tableProps.asyncProps))
        } else {
          throw new Error('not implemented yet')
        }
      } else {
        console.warn(`Are you trying to set properties on non-existent table ${tableId} ?`)
      }
    }
  }

  public setSorting(tableId: string, sortingRules?: ISortingRule[]) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const tableProps = getStore().data.featureTables[tableId]
      const layerInfo = getStore().layerInfos.featureLayerInfos[tableId]
      if (tableProps && layerInfo) {
        if (tableProps.asyncProps) {
          ;(tableProps as any).sorted = sortingRules
          ;(tableProps as any).defaultSorted = sortingRules
          dispatch(this.dispatchAsync(layerInfo, tableProps, tableProps.asyncProps))
        } else {
          throw new Error('not implemented yet')
        }
      } else {
        console.warn(`Are you trying to set properties on non-existent table ${tableId} ?`)
      }
    }
  }

  public setFeatureTables(tablesProps: Array<ITableProps>) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const tabInfosPaylod: {[key: string]: ITableProps} = {}
      const store = getStore()
      tablesProps.forEach(tableProps => {
        const layerInfo = store.layerInfos.featureLayerInfos[tableProps.id]
        if (tableProps.asyncProps) {
          dispatch(this.dispatchAsync(layerInfo, {...tableProps}, tableProps.asyncProps))
        } else {
          tableProps.query = ensureQuery(tableProps, layerInfo)
          dispatch(this.dispatchSync(layerInfo, tableProps))
        }
      })
    }
  }

  protected dispatchAsync(layerInfo: IFeatureLayerInfo, tableProps: ITableProps, asyncProps: IAsyncTableProps) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      if (!layerInfo) {
        return
      }
      const loadingTableProps: Partial<ITableProps> = {...tableProps}
      loadingTableProps.loading = true
      dispatch({
        type: DataActions.SEND_LOADING_TABLES,
        payload: {[layerInfo.url]: loadingTableProps}
      })
      const query = this.getQuery(tableProps, layerInfo, getStore().dataQueries[layerInfo.url])
      ServiceHub.gisCrudService
        .executeForCount(layerInfo, query)
        .then(count => {
          query.num = tableProps.pageSize!
          query.start = asyncProps.page * tableProps.pageSize!
          if (tableProps.sorted && tableProps.sorted.length > 0) {
            query.orderByFields = [`${tableProps.sorted[0].id} ${tableProps.sorted[0].desc ? 'DESC' : 'ASC'}`]
          } else {
            query.orderByFields = [`${layerInfo.sourceDescription.idField} ${'ASC'}`]
          }
          ServiceHub.gisCrudService
            .execute(layerInfo, query)
            .then(result => {
              tableProps.data = result
              tableProps.recordsCount = result.length
              tableProps.pages = 1
              tableProps.asyncProps = {
                pages:
                  (count - (count % tableProps.pageSize!)) / tableProps.pageSize! +
                  (count % tableProps.pageSize! > 0 ? 1 : 0),
                page: asyncProps.page,
                recordsCount: count
              }
              tableProps.loading = false
              delete tableProps.error
              dispatch({
                type: DataActions.ADD_ASYNC_TABS,
                payload: {[layerInfo.url]: tableProps}
              })
            })
            .catch(error => {
              console.warn(error)
              tableProps.loading = false
              tableProps.error = error
              dispatch({
                type: DataActions.ADD_SYNC_TABS,
                payload: {[layerInfo.url]: tableProps}
              })
              console.error(error)
            })
        })
        .catch(error => {
          loadingTableProps.loading = false
          loadingTableProps.error = error
          dispatch({
            type: DataActions.ADD_SYNC_TABS,
            payload: {[layerInfo.url]: loadingTableProps}
          })
          console.error(error)
        })
    }
  }
}
